import { MsalAuthProvider } from 'react-aad-msal';
import msal from '../../../configuration/msal';

export const authProvider = new MsalAuthProvider(msal.config, msal.authenticationParameters, msal.options)